import React from 'react'
import { Result } from 'antd'
import { Button } from 'ui/styled'

import StyledWrapper from './styled'

const PageNotFound = () => (
  <StyledWrapper>
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button
          btntype="primary"
          btnsize="custom"
          padding="0 15px"
          data-test="returnToTicketsBtn"
          href="/tickets"
        >
          Back to Tickets
        </Button>
      }
    />
  </StyledWrapper>
)

export default PageNotFound
